import React from 'react';
import { restaurantConfig } from '../config/restaurantConfig';
import { Link } from 'react-router-dom';

interface AboutProps {
  language: string;
}

export const About = ({ language }: AboutProps) => {
  const primaryColor = restaurantConfig.colors.primary;
  
  return (
    <section id="about" className="story-section py-16 relative overflow-hidden">
      {/* Background element */}
      <div className="left-bg absolute left-0 top-1/2 -translate-y-1/2 opacity-10">
        <img src="/images/background/bg-3.png" alt="" />
      </div>
      
      <div className="container mx-auto px-6 md:px-8 lg:px-4 relative z-10">
        <div className="row clearfix flex flex-col lg:flex-row items-center">
          {/* Text Column */}
          <div className="text-col lg:w-5/12 mb-10 lg:mb-0">
            <div className="inner pr-0 lg:pr-6 text-center px-4 md:px-6">
              <div className="title-box centered">
                <div className="subtitle">
                  <span className="inline-block text-[var(--color-pink)] font-medium text-base mb-2">
                    {language === 'en' ? 'OUR STORY' : 'A NOSSA HISTÓRIA'}
                  </span>
                </div>
                <div className="pattern-image mb-3 flex justify-center">
                  <svg width="80" height="20" viewBox="0 0 80 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 10 L80 10" stroke="var(--color-pink)" strokeWidth="1" />
                    <circle cx="40" cy="10" r="4" fill="var(--color-pink)" />
                    <circle cx="22" cy="10" r="2" fill="var(--color-pink)" />
                    <circle cx="58" cy="10" r="2" fill="var(--color-pink)" />
                  </svg>
                </div>
                <h2 className="text-2xl lg:text-3xl font-bold mb-4 font-fleur" style={{ color: primaryColor }}>
                  {language === 'en' ? 'The experience your palate has been waiting for.' : 'A experiência que faltava no seu paladar.'}
                </h2>
                <div className="text text-[var(--color-grey)] mb-6 text-sm leading-relaxed max-w-xl mx-auto">
                  {(language === 'en' ? restaurantConfig.about.en : restaurantConfig.about.pt)
                    .split('\n')
                    .map((paragraph, index) => (
                      <p key={index} className="mb-3">{paragraph}</p>
                    ))
                  }
                </div>
                
               
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="image-col lg:w-7/12">
            <div className="inner relative">
              <div className="images relative pl-0 lg:pl-6 mt-4 lg:mt-0 max-w-2xl mx-auto">
                <div className="image-1 relative z-10">
                  <img 
                    src="/images/about/about-1.jpg" 
                    alt="Restaurant View" 
                    className="w-full rounded-lg shadow-lg" 
                  />
                </div>
                <div className="image-2 absolute left-0 -bottom-20 lg:w-2/3 w-1/2 z-20">
                  <img 
                    src="/images/about/about-2.jpg" 
                    alt="Restaurant Cuisine" 
                    className="w-full rounded-lg shadow-lg border-4 border-white" 
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        .story-section {
          position: relative;
          background-color: #ffffff;
        }
        
        .booking-info .bk-no a:before {
          position: absolute;
          content: '';
          left: 5px;
          right: 5px;
          bottom: 0px;
          height: 5px;
          opacity: 0;
          transform: scale(0.2, 1);
          transition: all 500ms ease;
          border-top: 1px solid var(--color-pink);
          border-bottom: 1px solid var(--color-pink);
        }
        
        .booking-info .bk-no a:hover::before {
          opacity: 1;
          transform: scale(1, 1);
        }
        
        .images .image-1 {
          transition: transform 0.5s ease;
        }
        
        .images:hover .image-1 {
          transform: translateY(-5px);
        }
        
        .images .image-2 {
          transition: transform 0.5s ease;
        }
        
        .images:hover .image-2 {
          transform: translateY(5px) translateX(5px);
        }
        
        @media (max-width: 1023px) {
          .inner {
            padding-right: 0;
          }
          
          .images {
            padding-left: 0;
            margin-top: 2rem;
            max-width: 350px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 2rem;
            position: relative;
          }
          
          .image-1 {
            width: 100% !important;
            position: relative !important;
            z-index: 1;
          }
          
          .image-2 {
            position: absolute !important;
            right: 0 !important;
            bottom: 0 !important;
            transform: none !important;
            width: 60% !important;
            margin: 0 !important;
            z-index: 2;
          }
        }
      `}</style>
    </section>
  );
}; 